import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DeviceStoreService } from '../store/device.store';
import { updateDeviceInfo } from '../interface/devices-interface.i';
import { DevicesConstants } from '../../../../app/core/routing/services/devices/constants/devices.constants';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { CommonService } from '../../../common/services/common.service';

@Component({
  selector: 'iposcen-device-info',
  templateUrl: './device-info.component.html',
  styleUrls: ['./device-info.component.scss']
})
export class DeviceInfoComponent implements OnInit {
  @Output() readonly dismissFunc = new EventEmitter();
  @Input() deviceInfo;
  @Output() readonly lastUpdateTime = new EventEmitter();
  brand: string;
  deviceType: string;
  operatingSystem: string;
  processor: string;
  connectivityStatus: string;
  connectivityStatusText: string;
  deviceInfoForm: FormGroup;
  openModalPopup = false;
  deviceId: string;
  successMessage: string;
  description: string;
  payload;
  deviceName: any;
  skuID: any;
  batteryLife: any;
  isCancel = false;
  buttonLabelNo = DevicesConstants.NO;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  deviceNameLabel = DevicesConstants.DEVICENAME;
  skuIdLabel = DevicesConstants.SKUID;
  cancelLabel = GlobalConstants.CANCEL;
  saveChangesLabel = GlobalConstants.SAVE_CHANGES;
  isBatteryLifeEnabeled;
  convertText;

  constructor(private fb: FormBuilder, private googleAnalyticsService: GoogleAnalyticsService, 
    private deviceStore: DeviceStoreService,private CommonSer:CommonService) { }

  ngOnInit(): void {
    this.convertText = this.CommonSer;
    this.googleAnalyticsService.devieInfoTabName('Device Info');
    const storeData = this.deviceStore.deviceStoreData;
    if (!storeData?.deviceName) {
      this.deviceName = this.deviceInfo.deviceName;
      this.skuID = this.deviceInfo.skuID;
      this.batteryLife = typeof (this.deviceInfo.batteryLife) === 'number' ? this.deviceInfo.batteryLife
        : typeof (this.deviceInfo.batteryLife) === 'undefined' ? '' : +this.deviceInfo.batteryLife.split(' ')[0];
        if (this.deviceInfo.batteryLife == '') {
          this.batteryLife = '';
        }
      
    } else {
      this.deviceName = storeData.deviceName;
      this.skuID = storeData.skuID;
      this.batteryLife = +storeData.batteryLife;
    }
    this.deviceInfoForm = this.fb.group({
      deviceName: new FormControl(this.deviceName),
      skuID: new FormControl(this.skuID),
      batteryLife: new FormControl(this.batteryLife, Validators.min(1))
    });
    this.brand = this.deviceInfo?.brand;
    this.operatingSystem = this.deviceInfo?.operatingSystem;
    this.processor = (this.deviceInfo?.deviceConfigurations) ? JSON.parse(this.deviceInfo.deviceConfigurations)?.cpu?.display?.en_US : '';
    if(!this.processor) {
      this.processor = '';
    }
    this.connectivityStatus = this.deviceInfo?.connectivityStatus;
    this.connectivityStatusText = this.deviceInfo?.connectivityStatusText;
    this.deviceId = this.deviceInfo?.deviceID;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    const deviceType = this.deviceInfo.deviceType;
    if (deviceType === 'Standard Desktop' || deviceType === 'All-in-one Desktop') {
      this.deviceInfoForm.controls.batteryLife.disable();
    }
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  //GLS fix: Translation applied for Connectivity types
  spell(option: string) {
    if (option === GlobalConstants.ACTIVE_TEXT_OPTION) {
      return GlobalConstants.ACTIVE_TEXT;
    } else if (option === GlobalConstants.CONNECTED_TEXT_OPTION) {
      return GlobalConstants.CONNECTED_TEXT;
    } else if (option === GlobalConstants.DISCONNECTED_TEXT_OPTION) {
      return GlobalConstants.DISCONNECTED_TEXT;
    } 
  }

  sendDataToStore() {
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC
    if (this.deviceInfoForm.controls.batteryLife.value == null)  {
      this.deviceInfoForm.controls.batteryLife.setValue('');
    }
    this.payload = this.deviceInfoForm.value as updateDeviceInfo;
    this.deviceStore.updateDeviceData(this.payload);
    this.isCancel = false;
    this.lastUpdateTime.emit(true);
  }

  closeModal() {
    this.openModalPopup = !this.openModalPopup;
  }
}
